<template>
  <div class="formCla">
    <el-form ref="form" :model="form">
      <el-form-item label="主键id" v-if="show">
        <el-input v-model="form.id" size="small" ></el-input>
      </el-form-item>
      <el-form-item label="字段标识">
        <label slot="label">&emsp;&emsp;&emsp;字段标识</label>
        <el-col span="12">
          <el-input v-model="form.fieldId" size="small"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="展示名称">
        <label slot="label">&emsp;&emsp;&emsp;展示名称</label>
        <el-col span="12">
          <el-input v-model="form.fieldName" size="small"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="展示名称英文">
        <label slot="label">&emsp;展示名称英文</label>
        <el-col span="12">
          <el-input v-model="form.fieldEnName" size="small"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="展示名称中英文">
        <el-col span="12">
          <el-input v-model="form.fieldChEnName" size="small"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">保存</el-button>
        <el-button type="primary" @click="cancle">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
    export default {
        name: "addDataSetCol",
        show: false,
      data(){
          return{
            form: {
              id: this.$route.params.id,
              dsId: this.$route.params.ds_id,
              fieldId: this.$route.params.field_id,
              fieldName: this.$route.params.field_name,
              fieldEnName: this.$route.params.field_en_name,
              fieldChEnName: this.$route.params.field_ch_en_name,
            }
          }
      },
      mounted(){
      },
      methods:{
        cancle(){
          this.$router.push({name:'defineDataSet',params:{avtiveName: 'second'}});
        },
        onSubmit(){
          var flag = this.$route.params.flag
          if (flag == 'edit') {
            this.$http.post("/dbManage/sys-dataset-detail/updateDatasetDetail", this.form).then(resp=>{
              this.$router.push({name:"defineDataSet",params:{flags:'1', list: resp.data}});
            }
            )
          } else {
            this.$http.post("/dbManage/sys-dataset-detail/addDatasetDetail", this.form).then(resp=>{
              this.$router.push({name:"defineDataSet",params:{flags:'1', list: resp.data}});
            })

          }
        },
      }
    }
</script>

<style scoped>
.formCla{
  width: 60%;
  padding-left: 30%;
  padding-top: 5%;
}
</style>



// WEBPACK FOOTER //
// src/components/dataSource/addDataSetCol.vue